export default __webpack_public_path__ + "static/media/fNeutral15.9ba777f4.png";